import React from 'react'
import { Tree } from '@alicloud/console-components'

export default class Demo8 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [
        { label: 'Expand to load', key: '0', },
        { label: 'Expand to load', key: '1' },
        { label: 'Leaf', key: '2', isLeaf: true }
      ]
    }
    this.onLoadData = this.onLoadData.bind(this)
  }

  onLoadData(node) {
    return new Promise(resolve => {
      if (node.props.children) {
        return resolve();
      }

      const { eventKey, pos } = node.props
      const item = this.getItemByPos(pos)
      setTimeout(() => {
        item.children = [
          { label: 'Child Tree', key: `${eventKey}-0` },
          { label: 'Child Tree', key: `${eventKey}-1` }
        ]
        this.setState({
          data: [...this.state.data]
        })
        resolve();
      }, 1000)
    })
  }

  getItemByPos(pos) {
    return pos.split('-').slice(1).reduce((ret, num) => ret.children[num], { children: this.state.data });
  }

  render() {
    return (
      <Tree dataSource={this.state.data} loadData={this.onLoadData} />
    )
  }
}
;
  export const _demoSrcFiles = __demo_loader_placeholder__